<template>
  <div class="mx-4">
    <div v-bind:class="loading">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-bind:class="result">
      <div class="row">
        <div class="col-12 pb-0" style="display: flex; justify-content: center">
          <h4 class="mb-0">Excepciones</h4>
        </div>
        <div class="col-12 pt-0" style="display: flex; justify-content: flex-end">
          <v-btn color="primary" elevation="1" @click="Consultar">Consultar</v-btn>
        </div>
        <div class="col-12 mt-3">
          <v-card>
            <v-card-title style="display: flex">
              <v-col cols="12">
                <v-row style="display: flex; align-items: flex-end">
                  <v-col cols="3" class="pa-1 mx-2">
                    <v-dialog ref="dialogBegin" v-model="modalBegin" :return-value.sync="begin" persistent width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="dateRangeText"
                          label="Rango de fechas"
                          prepend-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          hide-details
                          class="pr-2 pb-1"
                        ></v-text-field>
                      </template>
                      <v-date-picker :title-date-format="titleDateFormat" v-model="begin" range locale="es">
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modalBegin = false"> Cancelar </v-btn>
                        <v-btn text color="primary" @click="$refs.dialogBegin.save(begin)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      solo
                      v-model="send.usuario_creacion"
                      label="Supervisor"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      solo
                      v-model="send.idactividad"
                      label="Codigo de excepción"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-text-field
                      hide-details
                      solo
                      v-model="send.mu"
                      label="MU"
                      type="number"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" class="pa-1 mx-2">
                    <v-autocomplete
                      hide-details
                      solo
                      v-model="send.nomestatus"
                      :items="filter.nomestatus"
                      item-text="name"
                      item-value="id"
                      label="Estatus"
                      dense
                      no-data-text="No se obtuvieron resultados"
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="8" class="pa-1">
                <v-btn elevation="2" @click="cleanFilter">Limpiar</v-btn>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar" single-line hide-details></v-text-field>
              </v-col>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="items"
              :search="search"
              disable-sort
              :items-per-page="itemsPerPage"
              class="elevation-1"
              loading-text="Cargando usuarios... Porfavor espere"
            >
              <template v-slot:item.fechas="{ item }">
                <span v-text="item.hora_inicio_evento + ' - ' + item.hora_fin_evento" />
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <div v-if="item.status == 'POR_APROBAR'" style="display: flex">
                  <button
                    class="btn btn-danger btn-sm"
                    style="margin-right: 5px"
                    v-on:click.prevent="Rechazar_Ausencia(item.idExcepcionSolicitud)"
                  >
                    Rechazar
                  </button>
                  <button
                    class="btn btn-success btn-sm"
                    style="margin-left: 5px"
                    v-on:click.prevent="Autorizar_Ausencia(item.idExcepcionSolicitud)"
                  >
                    Aprobar
                  </button>
                </div>
              </template>
              <template v-slot:no-data> No hay información disponible </template>
              <template v-slot:no-results> No se obtuvieron resultados </template>
            </v-data-table>
          </v-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GeneralMixin from "@/components/mixins/General";
import PaginationFooter from "@/components/General/PaginationFooter";
import axios from "axios";
import moment from "moment-timezone";

export default {
  mixins: [GeneralMixin],
  components: {
    PaginationFooter,
  },
  data() {
    return {
      url: process.env.VUE_APP_URL,
      headers: [
        { text: "ID de solicitud", align: "left", value: "idExcepcionSolicitud" },
        { text: "MU", align: "start", value: "mu" },
        { text: "Fecha de creación", align: "left", value: "fecha_creacion" },
        { text: "Supervisor", align: "left", value: "usuario_creacion" },
        { text: "Nombre Agente", align: "left", value: "nomagenteSistema" },
        { text: "Agente", align: "left", value: "idfirmarseSistema" },
        { text: "Codigo de excepción", align: "left", value: "idactividad" },
        { text: "Estado", align: "center", value: "status" },
        { text: "Dia", align: "center", value: "fecha_inicio" },
        { text: "Hora inicio", align: "center", value: "hora_inicio" },
        { text: "Hora fin", align: "center", value: "hora_fin" },
        { text: "Acciones", align: "center", value: "actions" },
      ],
      items: [],
      itemsBackup: [],
      filter: {
        nomestatus: [
          { name: "Pendiente de aprobación", id: "POR_APROBAR" },
          { name: "Aprobado", id: "APROBADO" },
          { name: "Rechazado", id: "RECHAZADO" },
          { name: "Enviado", id: "ENVIADO" },
        ],
      },
      send: {
        usuario_creacion: "",
        idactividad: "",
        nomestatus: "",
        mu: "",
      },
      modalBegin: false,
      search: "",
      loading: "",
      result: "d-none",
      excepciones: [],
      begin: [],
      data: {
        skip: 1,
        take: 10,
        filters: {
          fechas: this.begin,
        },
      },
      itemsPerPage: 10,
    };
  },
  methods: {
    async Consultar() {
      this.Cargando();
      try {
        // A futuro cambiara la estructura del proyecto y esto quedara en el router estos dos headers
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");

        const url = this.url + "/v2/api/admin/excepciones/solicitudes/list";
        let data = (this.data = {
          fecha_inicio: this.begin[0] + "T00:00",
          fecha_fin: this.begin[1] + "T23:59",
        });
        const { data: items } = await axios.post(url, { data });
        this.items = items.map((obj) => {
          return {
            ...obj,
            fecha_inicio: moment(obj.fecha_inicio).utc().format("DD-MM-YYYY"),
            hora_inicio: moment(obj.fecha_inicio).utc().format("HH:mm"),
            hora_fin: moment(obj.fecha_fin).utc().format("HH:mm"),
            fecha_creacion: moment(obj.fecha_creacion).utc().format("DD-MM-YYYY HH:mm"),
          };
        });
        this.itemsBackup = this.items;
        this.order();
        if (this.items != null) {
          this.excepciones = this.items;
        }
        if (this.excepciones.length === 0) {
          swal("No hay excepciones", "Por el momento no hay excepciones", "info");
        }
        this.loading = "d-none";
        this.result = "";
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
        this.Listo();
      }
    },
    order() {
      let data = this.send;
      this.items = _.filter(this.itemsBackup, function (o) {
        return (
          (data.usuario_creacion ? o.usuario_creacion == data.usuario_creacion : true) &&
          (data.idactividad ? o.idactividad == data.idactividad : true) &&
          (data.nomestatus ? o.status == data.nomestatus : true) &&
          (data.mu ? o.mu == data.mu : true)
        );
      });
    },
    Autorizar_Ausencia(idretardo_ausencia) {
      var that = this;
      swal({
        title: "¿Seguro que desea autorizar la solicitud?",
        text: 'Presiona "OK" para autorizar, "Cancel" para cancelar',
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          that.Si_Autorizar_Ausencia(idretardo_ausencia);
        } else {
        }
      });
    },
    Rechazar_Ausencia(idretardo_ausencia) {
      var that = this;
      swal({
        title: "¿Seguro que desea rechazar la solicitud?",
        text: 'Presiona "OK" para rechazar, "Cancel" para cancelar',
        icon: "info",
        buttons: true,
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          that.No_Autorizar_Ausencia(idretardo_ausencia);
        } else {
        }
      });
    },
    async Si_Autorizar_Ausencia(idExcepcionSolicitud) {
      this.Cargando();
      try {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");

        const url = this.url + "/v2/api/admin/excepciones/solicitudes/list";

        let data = (this.data = {
          idExcepcionSolicitud: idExcepcionSolicitud,
          status: "APROBADO",
        });
        await axios.post(url, { data });

        swal("Excepcion Aprobada", "La Excepcion fue autorizado con exito", "success");
        this.Consultar();
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
        this.Listo();
      }
    },
    Listo() {
      var that = this;
      this.loading = "d-none";
      this.result = "";
    },
    async No_Autorizar_Ausencia(idExcepcionSolicitud) {
      this.Cargando();
      try {
        axios.defaults.headers.common["Authorization"] = "Bearer " + localStorage.getItem("apiKey_tp");
        axios.defaults.headers.common["accesstoken"] = localStorage.getItem("tokenmsal");

        const url = this.url + "/v2/api/admin/excepciones/solicitudes/list";

        let data = (this.data = {
          idExcepcionSolicitud: idExcepcionSolicitud,
          status: "RECHAZADO",
        });
        await axios.post(url, { data });

        swal("Excepcion Rechazada", "La Excepcion fue autorizado con exito", "success");
        this.Consultar();
      } catch (error) {
        if (error.body?.code === "MSAL_TOKEN_IS_NOT_VALID") {
          this.$msal.signOut();
        }
        if (error.response.data.code === "INVALID_TOKEN") {
          // Redirigir al usuario a la página de inicio de sesión
          this.$msal.signOut();
          this.$router.push({ name: "Login" });
        }
        if (error.status !== 401) {
          swal("Problemas para conectarse", "Favor de revisar su conexión a internet", "error");
        }
        this.Listo();
      }
    },
    Cargando() {
      this.loading = "";
      this.result = "d-none";
    },
    cleanFilter() {
      for (let key in this.send) {
        this.send[key] = "";
      }
      this.Consultar();
    },
    preventExponential(event) {
      // Si la tecla presionada es la "e", prevenir su entrada
      if (event.key === "e") {
        event.preventDefault();
      }
    },
  },
  computed: {
    menu() {
      return this.$store.getters.getMenu;
    },
    dateRangeText() {
      return this.begin.join(" ~ ");
    },
    titleDateFormat() {
      // Aquí puedes incluir la clase personalizada en la cadena de formato de fecha
      return (date) => {
        return this.$vuetify.lang.t("Fechas seleccionadas");
      };
    },
  },
  created() {
    const today = new Date();
    const sevenDaysAgo = new Date(today);
    sevenDaysAgo.setDate(today.getDate() - 7);
    this.begin = [sevenDaysAgo.toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)];
    this.Consultar();
  },
};
</script>

<style>
.v-select__selection--comma {
  font-size: 0.75rem;
}
</style>
